import { render, staticRenderFns } from "./roleauthorityset.vue?vue&type=template&id=a7a690c6&scoped=true&"
import script from "./roleauthorityset.vue?vue&type=script&lang=js&"
export * from "./roleauthorityset.vue?vue&type=script&lang=js&"
import style0 from "./roleauthorityset.vue?vue&type=style&index=0&id=a7a690c6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7a690c6",
  null
  
)

export default component.exports